import React, { useState } from "react";
import "../ReleasePage.css";

export default function ReleasePage() {
  const [activePage, setActivePage] = useState("requests");
  const [password, setPassword] = useState("");
  const [isAuthorized, setIsAuthorized] = useState(false);

  const handlePasswordSubmit = () => {
    if (password === "yourSecret") {
      setIsAuthorized(true);
    } else {
      alert("Incorrect password");
    }
  };

  return (
    <div className="release-page">
      <h1>Release Portal</h1>

      {/* Navigation */}
      <div className="page-nav">
        <button onClick={() => setActivePage("requests")}>Requests</button>
        <button onClick={() => setActivePage("completed")}>Completed</button>
        <button onClick={() => setActivePage("calendar")}>Calendar</button>
        <button onClick={() => setActivePage("admin")}>Admin</button>
      </div>

      {/* Page Content */}
      <div className="page-content">
        {activePage === "requests" && (
          <section className="request-section">
            <h2>Request Form</h2>
            <form className="request-form">
              <label htmlFor="name">Name</label>
              <input type="text" id="name" placeholder="Your Name" />

              <label htmlFor="request">Request</label>
              <textarea id="request" placeholder="Your request"></textarea>

              <label htmlFor="type">Type</label>
              <select id="type">
                <option value="feature">Feature</option>
                <option value="bug">Bug</option>
              </select>

              <button type="submit">Submit</button>
            </form>
          </section>
        )}

        {activePage === "completed" && (
          <section className="completed-section">
            <h2>Completed Requests</h2>
            <ul className="completed-list">
              <li>Request 1 completed</li>
              <li>Request 2 completed</li>
            </ul>
          </section>
        )}

        {activePage === "calendar" && (
          <section className="calendar-section">
            <h2>Calendar</h2>
            <div className="calendar-controls">
              <button>Prev</button>
              <span>October 2025</span>
              <button>Next</button>
            </div>
            <div className="calendar-grid">
              <div className="calendar-week">
                <div className="calendar-day">
                  <div className="day-number">1</div>
                  <div className="calendar-item">
                    <span className="status-bubble green"></span>
                    Meeting
                  </div>
                </div>
                {/* Repeat days as needed */}
              </div>
            </div>
          </section>
        )}

        {activePage === "admin" && (
          <section className="calendar-admin">
            <h2>Admin</h2>
            {!isAuthorized ? (
              <div className="admin-login">
                <input
                  type="password"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button onClick={handlePasswordSubmit}>Enter</button>
              </div>
            ) : (
              <div className="admin-content">
                <form className="calendar-form">
                  <input type="text" placeholder="Add Event" />
                  <select>
                    <option value="meeting">Meeting</option>
                    <option value="holiday">Holiday</option>
                  </select>
                  <button type="submit" className="save-btn">
                    Save
                  </button>
                  <button type="button" className="cancel-btn">
                    Cancel
                  </button>
                </form>

                <table className="calendar-table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Event</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>2025-10-27</td>
                      <td>Team Meeting</td>
                      <td>
                        <button className="edit-btn">Edit</button>
                        <button className="delete-btn">Delete</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </section>
        )}
      </div>
    </div>
  );
}
